<template>
  <div class="row justify-center" style="padding-bottom: 120px">
    <TileBar
      v-if="$q.screen.gt.xs"
      option-button="Back"
      @on-button="$router.go(-1)"
    />
    <TileBar
      class="q-mt-sm"
      title="Customer List"
      option-button="Add"
      @on-button="onAddCustomer"
    />

    <q-separator />

    <div class="col-12 bg-white col-12 col-sm-10 col-md-9 bg-white " style="padding:6px 16px;">
      <q-list clickable>
        <q-item
          style="margin: 10px 0"
          class="bg-info" 
          v-for="(customer, index) in customerList"
          :key="index"
        >
          <q-item-section>
            <q-item-label>{{ customer.name }}</q-item-label>
            <q-item-label caption>{{ customer.email }}</q-item-label>
            <q-item-label caption>{{ customer.address.address }}</q-item-label>
            <q-item-label caption>{{ customer.phone }}</q-item-label>
          </q-item-section>
          <div class="column justify-between">
            <q-btn no-caps flat color="primary" dense label="Edit"></q-btn>
            <q-btn no-caps flat color="primary" dense label="Remove" @click="onRemoveCustomer(index)"></q-btn>
          </div>
        </q-item>
      </q-list>
    </div>
    <q-dialog v-model="addCustomerDialog.show" persistent>
      <add-customer-dialog/>
    </q-dialog>
    <q-dialog v-model="removeCustomerDialog.show" persistent>
      <DialogAlert
        message="Do you want to remove?"
        left-btn="Cancel"
        right-btn="Confirm"
        @leftClick="onCancel"
        @rightClick="onConfirmRemoveCustomer"
      />
    </q-dialog>
  </div>
</template>

<script>
import { QSeparator, QList, QBtn, QDialog, QForm } from "quasar";
import AddCustomerDialogVue from '@/ui/components/AddCustomerDialog.vue';

const components = { QSeparator, QList, QBtn, QDialog, QForm };

export default {
  name: "Customer",
  components: {
    ...components,
    TileBar: () => import(`@/ui/components/TileBar.vue`),
    DialogAlert: () => import("@/ui/components/DialogAlert.vue"),
    AddCustomerDialog: () => import("@/ui/components/AddCustomerDialog.vue")
  },
  data() {
    return {
      customerList: [
        {
          name: "Test Customer1",
          address: {
            name: "Home",
            address: "1314 Pak Kret Amphoe Pak Kret Nonthaburi 11120",
          },
          email: "Customer1@gmail.com",
          phone: "092-1234567",
        },
        {
          name: "Test Customer2",
          address: {
            name: "Home",
            address: "66/20 Pak Kret Amphoe Pak Kret Nonthaburi 11120",
          },
          email: "Customer2@gmail.com",
          phone: "092-1234567",
        },
        {
          name: "Test Customer3",
          address: {
            name: "Home",
            address: "41/99 Pak Kret Amphoe Pak Kret Nonthaburi 11120",
          },
          email: "Customer3@gmail.com",
          phone: "092-1234567",
        },
        {
          name: "Test Customer4",
          address: {
            name: "Home",
            address: "50/109 Pak Kret Amphoe Pak Kret Nonthaburi 11120",
          },
          email: "Customer4@gmail.com",
          phone: "092-1234567",
        },
      ],
      addCustomerDialog: {
        show: false,
        form: {
          name: null,
          email: null,
          address: null,
          phone: null,
        },
      },
      removeCustomerDialog: {
        show: false,
        index: null,
      }
    };
  },
  methods: {
    onRightClick() {
      console.log("Add");
    },
    onAddCustomer() {
      console.log("Add customer");
      this.addCustomerDialog.show = true;
    },
    onAddCustomerSubmit(){
      console.log("create new customer");
      this.customerList.push({
        name: this.addCustomerDialog.form.name,
        address: {
          name: "Home",
          address: this.addCustomerDialog.form.address,
        },
        phone: this.addCustomerDialog.form.phone,
        email: this.addCustomerDialog.form.email,
      });
      this.addCustomerDialog.show = false;
    },
    onRemoveCustomer(index){
      this.removeCustomerDialog.index = index;
      this.removeCustomerDialog.show = true;
    },
    onConfirmRemoveCustomer(){
      this.customerList = this.customerList.filter((customer, idx) => idx != this.removeCustomerDialog.index);
      this.removeCustomerDialog.index = null;
      this.removeCustomerDialog.show = false;
    },
    onCancel(){
      this.removeCustomerDialog.show = false;
    }
  },
};
</script>

<style scoped></style>
